const IOS_DEVICE_PATTERN = /iPad|iPhone|iPod/i;

export const getInstallEnvironment = ({
  navigatorLike = globalThis.navigator,
  matchMedia = globalThis.matchMedia
} = {}) => {
  const userAgent = String(navigatorLike?.userAgent || '');
  const platform = String(navigatorLike?.platform || '');
  const maxTouchPoints = Number(navigatorLike?.maxTouchPoints || 0);
  const ios = IOS_DEVICE_PATTERN.test(userAgent)
    || (platform === 'MacIntel' && maxTouchPoints > 1);
  const standalone = navigatorLike?.standalone === true
    || Boolean(typeof matchMedia === 'function' && matchMedia('(display-mode: standalone)')?.matches);

  return { ios, standalone };
};
